import { render } from "./LicenseAdminsList.vue?vue&type=template&id=4bce173f&ts=true"
import script from "./LicenseAdminsList.vue?vue&type=script&lang=ts"
export * from "./LicenseAdminsList.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__